import React from 'react';

export const useOverscrollBehaviorFix = () => {
    React.useEffect(() => {
        // Disable overscroll behavior for the sidebar
        document.body.style.overscrollBehavior = 'none';

        return () => {
            // Re-enable overscroll behavior when the component unmounts
            document.body.style.overscrollBehavior = '';
        };
    }, []);
};
